import React, { useEffect } from 'react';
import { MotorhomeTabPanel } from '@/components/blocks/MotorhomeDetails/MotorhomeTabPanel';
import { usePathname } from 'next/dist/client/components/navigation';
import { useRouter } from 'next/router';
import Button from '../../elements/Button';
import { IMotorhomeTabs } from './MotorhomeDetails';

export const MotorhomeTabContent = ({ tabItems }: { tabItems: IMotorhomeTabs[] }) => {
    const router = useRouter();
    const [activeTabName, setActiveTabName] = React.useState<string>(router.asPath.split('#')[1] || tabItems[0].name);
    const pathname = usePathname();
    const activeTab = tabItems.find((t) => t.name === activeTabName) || tabItems[0];

    useEffect(() => {
        const activeTabName = window.location.hash.split('#')[1];
        if (activeTabName) {
            const el = document.getElementById(activeTabName);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, []);

    return (
        <>
            <div className="flex items-center justify-center">
                <div className="bg-rock text-primary text-center rounded-3xl w-full sm:w-auto sm:rounded-full flex flex-col sm:flex-row items-center justify-center gap-2 p-4">
                    {tabItems.map((tab, i) => {
                        return (
                            <Button
                                key={i}
                                variant={activeTab?.title === tab.title ? 'fill' : !activeTab && i === 0 ? 'fill' : 'ghost'}
                                colour={activeTab?.title === tab.title ? 'white' : !activeTab && i === 0 ? 'white' : 'primary'}
                                id={i.toString()}
                                disabled={activeTab?.title === tab.title}
                                onClick={() => {
                                    setActiveTabName(tab.name);
                                    history.pushState(null, '', `/${router.locale}${pathname}#${tab.name}`);
                                }}
                                className="disabled:opacity-100 w-full sm:w-auto"
                            >
                                <h6>{tab.title}</h6>
                            </Button>
                        );
                    })}
                </div>
            </div>

            <div className="text-primary mt-5 lg:mt-12 min-h-[50vh]">
                <MotorhomeTabPanel tab={activeTab} />
            </div>
        </>
    );
};
